import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-license-agreement',
  templateUrl: './license-agreement.component.html',
  styleUrls: ['./license-agreement.component.scss']
})
export class LicenseAgreementComponent implements OnInit, OnChanges {
  @Input() licensedData : any = '';
  CurrentLicenseData : any;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['licensedData']) {
      this.CurrentLicenseData = this.licensedData;
    }
  }

  close() {
      this.commonService.closePopUp();
  }

}
